var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('RegularFilterSelector',{attrs:{"filter":_vm.filter,"disabled":_vm.disabled,"placeholder":_vm.placeholder,"round":true,"show-label":false},on:{"selectedValuesChange":function($event){return _vm.$emit('selectedValuesChange', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }